<form
  [formGroup]="form"
  (ngSubmit)="confirm()"
  class="flex flex-col">
  <div class="flex flex-col">
    <div class="flex w-full justify-between gap-4 py-4 border-b border-neutral-300">
      <span class="text-[18px] font-black">
        <i
          class="pi pi-file-edit"
          style="font-size: 2rem"></i>
        SUBSANACION DE DESPLIEGUE DE SISTEMA
      </span>
      <div class="flex gap-4">
        <app-buttons
          [label]="'Detalle de subsanación'"
          (click)="goToSummary()" />
        <app-buttons
          [label]="'Continuar'"
          [disabled]="form.invalid || hasPendingObservedFieldsInStep()"
          [classes]="'bg-primary-base text-primary-light'"
          (click)="confirm()"
          type="button" />
      </div>
    </div>

    <div class="flex flex-col py-4">
      <span class="font-regular text-[18px]">Paso 1 de 6</span>
      <h2 class="font-bold text-[24px] pb-6">Gestión del riesgo</h2>

      <div class="flex flex-col relative">
        <div
          class="text-[16px]"
          [ngClass]="{ 'relative -top-4': isObserved('biases') }">
          Sesgos identificados
          <span *ngIf="highRiskFieldsRequired()">*</span>
        </div>
        <app-observed-field-alert
          *ngIf="isObserved('biases')"
          class="absolute top-2 left-0"></app-observed-field-alert>
      </div>
      <desy-textarea
        formControlName="biases"
        placeholder="Sesgos identificados en los datos de entrenamiento o en la salida del modelo."
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="5"
        [maxlength]="1000"></desy-textarea>
      <ng-container *ngIf="getError(form, 'biases', formSubmitted()) as error; else biasesInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #biasesInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 1000 caracteres</span>
      </ng-template>

      <div class="flex flex-col relative mt-4">
        <div
          class="text-[16px]"
          [ngClass]="{ 'relative -top-4': isObserved('risks') }">
          Riesgos identificados
          <span *ngIf="highRiskFieldsRequired()">*</span>
        </div>
        <app-observed-field-alert
          *ngIf="isObserved('risks')"
          class="absolute top-2 left-0"></app-observed-field-alert>
      </div>
      <desy-textarea
        formControlName="risks"
        placeholder="Riesgos que se han detectado durante la evaluación, diseño, entrenamiento o despliegue del sistema de IA."
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="5"
        [maxlength]="1000"></desy-textarea>
      <ng-container *ngIf="getError(form, 'risks', formSubmitted()) as error; else risksInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #risksInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 1000 caracteres</span>
      </ng-template>
    </div>
  </div>
</form>
